import React from 'react';
import {
  Heart,
  Users,
  MessageCircle,
  Shield,
  Sparkles,
  Home,
  Clock,
  BookOpen,
  ArrowRight
} from 'lucide-react';
import { modules } from '../data/mockData';
import { Button } from './ui/button';

const iconMap = {
  Heart: Heart,
  Users: Users,
  MessageCircle: MessageCircle,
  Shield: Shield,
  Sparkles: Sparkles,
  Home: Home,
  BookOpen: BookOpen,
};

const ModulesSection = ({ onStartCourse }) => {
  return (
    <section id="modulos" className="relative py-32 bg-background">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[200px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tight mb-6">
            DENTRO DE LA <span className="text-primary">CAPACITACIÓN</span>
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Accede a 55 minutos de contenido que combina psicoeducación clara,
            ejercicios de autorreflexión y herramientas concretas para ayudarte a
            acompañar al niño con más calma y seguridad.
          </p>
        </div>

        {/* Modules Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {modules.map((module) => {
            const Icon = iconMap[module.icon];
            return (
              <div
                key={module.id}
                className="group relative overflow-hidden rounded-2xl bg-gradient-to-b from-primary-foreground/70 to-primary-foreground/40 border border-primary/20 hover:border-primary/50 transition-all duration-500 shadow-sm hover:shadow-md"
              >
                {/* Module Number Badge */}
                <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-primary/20 border border-primary/30 flex items-center justify-center">
                  <span className="text-primary font-bold text-sm">
                    {module.id}
                  </span>
                </div>

                <div className="p-6">
                  {/* Icon */}
                  <div className="mb-4">
                    <div className="inline-flex p-3 rounded-xl bg-gradient-to-br from-primary/20 to-accent/20 border border-primary/30">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                  </div>

                  {/* Title */}
                  <h3 className="text-xl font-bold text-foreground mb-3 group-hover:text-primary transition-colors duration-300">
                    {module.title}
                  </h3>

                  {/* Description */}
                  <p className="text-muted-foreground text-sm leading-relaxed mb-4">
                    {module.description}
                  </p>

                  {/* Meta info */}
                  <div className="flex items-center gap-4 text-sm text-muted-foreground/80">
                    <div className="flex items-center gap-1.5">
                      <Clock className="w-4 h-4" />
                      <span>{module.duration}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <BookOpen className="w-4 h-4" />
                      <span>{module.lessons} lecciones</span>
                    </div>
                  </div>
                </div>

                {/* Hover gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            onClick={onStartCourse}
            className="group bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-lg font-semibold rounded-full transition-all duration-300 hover:scale-105 shadow-[0_0_40px_hsl(var(--primary)/0.3)]"
          >
            <span className="flex items-center gap-3">
              Comenzar mi Capacitación
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </span>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ModulesSection;
